<template>
  <div class="animated fadeIn" id="list-decomptes">
    <transition name="fade">
      <b-card no-body>
        <div slot="header">
          <i class="fa fa-justify mr-2"></i>
          <strong>Gestion des statuts Prest'IJ</strong>
        </div>
        <b-card-body class="small-padding">
          <b-row class="">
            <b-col md="6">
              <SlickList  lockAxis="y" v-model="allStatus" class="list-group" :useDragHandle="true" @sort-end="">
                <item-list v-for="(status, index) in allStatus" :index="index" :key="index" :item="status" :selectedItemId="statusId">{{ status.libelle }}<i v-if="canManageStatus()" class="icon fa fa-trash float-right clickable ml-2 text-danger" @click="deleteStatus(status.id)"></i><i v-if="canManageStatus()" class="icon fa fa-pencil float-right clickable" @click="edit(status)"></i></item-list>
              </SlickList>
            </b-col>
            <b-col md="6">
              <b-card :header-bg-variant="action === 'create' ? 'primary' : 'warning' ">
                <template v-slot:header >
                   <i class="fa fa-justify mr-2"></i>
                  <strong>{{ libelleFormCardTitle }}</strong>
                </template>
                <b-row>
                  <b-col md="12">
                    <b-form-group
                      label='Libellé'
                      label-for='libelle'
                    >
                      <b-form-input id='libelle' type='text' v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                      <span class='field-error'>{{ errors.libelle }}</span>
                    </b-form-group>
                    <b-form-group
                      label='Libellé technique'
                      label-for='libelleTechnique'
                    >
                      <b-form-input id='libelleTechnique' type='text' v-model="libelleTechnique" :class="{hasError: errors.libelleTechnique !== ''}" :disabled="action !== 'create'"></b-form-input>
                      <span class='field-error'>{{ errors.libelleTechnique }}</span>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12">
                    <b-button v-if="action === 'create'" size="md" variant="primary" @click="create()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Créer</b-button>
                    <b-button v-if="action === 'modify'" size="md" variant="warning" @click="modify()" class="mr-2 mt-1 pull-right"><i class="fa fa-save"></i> Modifier</b-button>
                    <b-button type="button" @click.prevent="clearForm()" size="md" variant="secondary" class="mr-2 mt-1 pull-right">
                      <i class="fa fa-eraser"></i> Annuler
                    </b-button>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </transition>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '@/utils/auth'
import { hasRule, rules } from "@/utils/rulesHelper"
import { SlickList } from 'vue-slicksort'
import itemList from '@/components/SortListItem'

export default {
  components: {
    SlickList,
    itemList
  },
  data() {
    return {
      statusId: '',
      allStatus: [],
      libelle: '',
      libelleTechnique: '',
      action: 'create',
      libelleFormCardTitle: 'Création d\'un statut Prest\'IJ',
      errors: {
        libelle: '',
        libelleTechnique: '',
      }
    }
  },
  watch: {
    allStatus: function() {
      if (this.canManageStatus()) {
        this.sorted()
      }
    },
  },
  mounted() {
    this.getStatus()
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
    this.$axios.defaults.headers.common['Accept'] = 'application/json';
    this.$axios.defaults.headers.common['Provider'] = getProvider();
  },
  methods: {
    getStatus() {
      let self = this

      this.$store.commit("IS_LOADING", true)
      this.$axios
        .get("/statutPrestij/all")
        .then(response => {
          this.$store.commit("IS_LOADING", false)

          this.allStatus = response.data.data
        })
        .catch(function(error) {
          // console.log(error)
          self.$store.commit("IS_LOADING", false)
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          })
        })
    },
    sorted() {
      // console.log(this.allBaskets)
      let self = this;
      let dataPost = {
        'provider': getProvider(),
        'status': this.allStatus
      }
      this.$store.commit('IS_LOADING', true)
      this.$axios
        .post('/statutPrestij/sort', dataPost)
        .then(response => {
          this.$store.commit('IS_LOADING', false)
          // console.log(response)
          // this.groupBals = _.groupBy(response.data.bals,'entreprise')
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          self.$swal({
            position: 'top',
            type: 'error',
            title: 'Attention !!',
            text: 'Une erreur est survenue lors du tri, si le problème persiste merci de faire un ticket au support DOSI',
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    create() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'libelle_technique': this.libelleTechnique,
          'ordre': 99,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/statutPrestij/add', dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearForm()
            this.clearError()
            this.getStatus()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la création du statut, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    modify() {
      if (this.validate()) {
        let self = this;
        let dataPost = {
          // 'provider': getProvider(),
          'libelle': this.libelle,
          'libelle_technique': this.libelleTechnique,
        }
        this.$store.commit('IS_LOADING', true)
        this.$axios
          .post('/statutPrestij/modify/'+this.statusId, dataPost)
          .then(response => {
            this.$store.commit('IS_LOADING', false)
            this.clearForm()
            this.clearError()
            this.getStatus()
          })
          .catch(function(error) {
            self.$store.commit('IS_LOADING', false)
            self.$swal({
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: 'Une erreur est survenue lors de la modification du statut, si le problème persiste merci de faire un ticket au support DOSI',
              showConfirmButton: false,
              timer: 5000
            });
          });
      }
    },
    deleteStatus(statusId) {
      let self = this;
      this.$swal
        .fire({
          title: "Êtes-vous sûr?",
          text: "Voulez-vous vraiment supprimer ce statut ?",
          type: "warning",
          reverseButtons: true,
          showCancelButton: true,
          allowOutsideClick: false,
          cancelButtonColor: "#ff1744",
          confirmButtonText: "Annuler",
          cancelButtonText: "Supprimer"
        })
        .then(result => {
          if (!result.value) {
            this.$store.commit("IS_LOADING", true)
            this.$axios
              .get("/statutPrestij/delete/"+statusId).then(response => {
                this.$store.commit("IS_LOADING", false)
                this.getStatus()
              })
              .catch(function(error) {
                  self.$store.commit("IS_LOADING", false)
                  console.log(error.response.status)
                  let errorText = "Une erreur est survenue, lors de la suppression du statut. Si le problème persiste, merci de faire un ticket au support DOSI."
                  if (error.response.status === 403) { errorText = "Vous n'êtes pas autorisé à effectuer cette action" }
                  self.$swal({
                  position: "top",
                  type:"error",
                  title:"Attention !!",
                  text:errorText,
                  showConfirmButton: false,
                  timer: 5000
                })
              })
          }
        })
    },
    canManageStatus() {
      return hasRule(rules.MANAGE_TABLE_STATUT_PRESTIJ)
    },
    edit(status) {
      this.libelle = status.libelle
      this.libelleTechnique = status.libelle_technique
      this.statusId = status.id
      this.action = 'modify'
      this.libelleFormCardTitle = 'Modification du statut Prest\'IJ : ' + status.libelle
    },
    validate() {
      let valid = true

      if (this.libelle === '') {
        this.errors.libelle = 'Le libelle est obligatoire'
        valid = false;
      }

      if (this.libelleTechnique === '') {
        this.errors.libelleTechnique = 'Le libelle technique est obligatoire'
        valid = false;
      }

      return valid
    },
    clearForm() {
      this.clearError()
      this.libelle = ''
      this.libelleTechnique = ''
      this.statusId = ''
      this.action = 'create'
      this.libelleFormCardTitle = 'Création d\'un statut Prest\'IJ'
    },
    clearError() {
      this.errors.libelle = ''
      this.errors.libelleTechnique = ''
    },
  }
}
</script>